import React, {Component} from 'react';
import {connect} from 'react-redux';
import {resources, scopes} from '../../../../common/permissions/dictionary';
import {hasAccessPermission} from '../../../../common/permissions/validations';
import {Button, Icon, Popup} from 'semantic-ui-react';

export class DispatchOrderProcessButtons extends Component {
  handleIngressedButtonsClick = (e, value) => {
    this.props.sendToApproval(value);
  }
  handleApprovalButtonsClick = (e, value) => {
    this.props.approveOrder(value);
  }
  handleProcessButtonClick = (e) => {
    this.props.processOrder();
  }
  hideButtonWhenNoVehiclesSelected = () => {
    const {vehiclesSelected} = this.props;
    return vehiclesSelected === 0 ? 'hide' : '';
  }
  render() {
    const {status, invoiceType, notificationGroup} = this.props;
    if (!status) {
      if (!hasAccessPermission(this.props.permissions, resources.DispatchOrders, scopes.Create)) {
        return null;
      }
      return (
        notificationGroup ? <div className={`flex grow end ${this.hideButtonWhenNoVehiclesSelected()}`}>
          <Popup content='Crear Orden de Despacho' inverted trigger={
            <Button type='submit' secondary size='big' compact
              style={{'padding': '2px 0 8px 0'}} icon={
                <Icon name='save' size='big' color='green' link />
              }>
            </Button>
          } />
        </div> : ''
      );
    }
    switch (status) {
      case 'E':
        if (!hasAccessPermission(this.props.permissions, resources.DispatchOrdersApproval, scopes.Approve)) {
          return null;
        }
        return (
          <div className='flex'>
            <div>
              <Button primary className='download' onClick={(e) => this.handleApprovalButtonsClick(e, true)}>
                <Icon name='check' />
                <span>APROBAR</span>
              </Button>
            </div>
            <div className='flex grow end'>
              <Button primary className='download' onClick={(e) => this.handleApprovalButtonsClick(e, false)}>
                <Icon name='close' />
                <span>RECHAZAR</span>
              </Button>
            </div>
          </div>
        );
      case 'I':
        if (!hasAccessPermission(this.props.permissions, resources.DispatchOrders, scopes.Create) &&
          !hasAccessPermission(this.props.permissions, resources.DispatchOrders, scopes.Edit)) {
          return null;
        }
        return (
          <div className='flex'>
            <div className={`${this.hideButtonWhenNoVehiclesSelected()}`}>
              <Popup content='Guardar los cambios' inverted trigger={
                <Button type='submit' secondary size='big' compact
                  style={{'padding': '2px 0 8px 0'}} icon={
                    <Icon name='save' size='big' color='green' link
                      onClick={(e) => this.handleIngressedButtonsClick(e, false)}/>
                  }>
                </Button>
              } />
              <Popup content='Anular orden' inverted trigger={
                <Button secondary size='big' compact
                  style={{'padding': '2px 0 8px 0'}} icon={
                    <Icon name='trash' size='big' color='red' link
                      onClick={(e) => {
                        e.preventDefault();
                        this.props.cancelOrder();
                      }}/>
                  }>
                </Button>
              } />
            </div>
            {invoiceType === 'N' ?
              notificationGroup &&
              <div className={`flex grow end ${this.hideButtonWhenNoVehiclesSelected()}`}>
                <Button primary className='download' onClick={(e) => this.handleProcessButtonClick(e)}>
                  <Icon name='send' />
                  <span>PROCESAR</span>
                </Button>
              </div> :
              notificationGroup && <div className={`flex grow end ${this.hideButtonWhenNoVehiclesSelected()}`}>
                <Button primary className='download' onClick={(e) => this.handleIngressedButtonsClick(e, true)}>
                  <Icon name='send' />
                  <span>ENVIAR</span>
                </Button>
              </div>
            }
          </div>
        );
      
      case 'P':
        if (!hasAccessPermission(this.props.permissions, resources.DispatchOrders, scopes.Create) &&
        !hasAccessPermission(this.props.permissions, resources.DispatchOrders, scopes.Edit)) {
          return null;
        }
        return (
          <div className='flex end'>
            <Popup content='Anular orden' inverted trigger={
              <Button secondary size='big' compact
                style={{'padding': '2px 0 8px 0'}} icon={
                  <Icon name='trash' size='big' color='red' link
                    onClick={(e) => {
                      e.preventDefault();
                      this.props.cancelOrder();
                    }}/>
                }>
              </Button>
            } />
          </div>
        );

      default:
        return '';
    }
  }
}

const mapStateToProps = (state) => {
  return {
    'permissions': state.session.permissions,
  };
};
  
export default connect(mapStateToProps)(DispatchOrderProcessButtons);
